import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import ActivityCard from '../components/ActivityCard';
import { activities } from '../mock';
import { useApp } from '../context/AppContext';

export default function Wishlist() {
  const { wishlist } = useApp();
  const items = activities.filter((a) => wishlist.includes(a.id));

  return (
    <div className="container-k py-4 md:py-8">
      <h1 className="text-xl md:text-3xl font-extrabold text-gray-900 mb-1">Your wishlist</h1>
      <p className="text-sm text-gray-500 mb-5">{items.length} saved experiences</p>

      {items.length === 0 ? (
        <div className="text-center py-16">
          <Heart className="w-12 h-12 mx-auto text-gray-300 mb-3" />
          <h2 className="font-semibold text-gray-800">No saved activities yet</h2>
          <p className="text-sm text-gray-500 mb-4">Tap the heart icon to save for later.</p>
          <Link to="/"><Button className="rounded-full bg-xlook-orange hover:opacity-90 text-white px-6">Browse activities</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {items.map((a) => <ActivityCard key={a.id} activity={a} />)}
        </div>
      )}
    </div>
  );
}
